export default __webpack_public_path__ + "34ce47dcdc8f1a118f7b4e090a30cd0d.png";